// Centralized constants for Rewards Display
export const ALERT_MIN = 0;
export const ALERT_MAX = 100;
export const IMAGE_SLOTS = 3;
